import { cast, flow, getRoot, Instance, types } from 'mobx-state-tree';
import { CmsApi } from 'service/axios-api';
import { IRootStore } from './root';
import { LocField, ProductSelector } from './localizations/umbraco';

export interface IPromotion extends Instance<typeof Promotion> {}

const Promotion = types.model('Promotion', {
    id: types.identifierNumber,
    banner: LocField,
    link: LocField,
    name: types.string,
    promosFor: ProductSelector,
});

// cross promotions
export default types
    .model('CrossPromotions', {
        banners: types.array(Promotion),
    })
    .views((self) => {
        const views = {
            get root(): IRootStore {
                return getRoot<IRootStore>(self);
            },
            get filtered() {
                return self.banners.filter(
                    (x) => !(views.root.session.not_popup_ads && views.root.session.dismissed_banners.includes(x.id))
                );
            },
        };
        return views;
    })
    .actions((self) => ({
        fetch: flow(function* (filtering = []) {
            let list: any = yield CmsApi.get('/frontend/v3/{regionWebCode}/cross-promos.json').catch(() => []);
            list = list.map((one: any) => ({
                ...one,
                target: one.target === 'Nexon' ? null : one.target,
                promosFor: one.promosFor === 'Nexon' ? null : one.promosFor,
            }));
            if (filtering.length > 0) self.banners = cast(list.filter((item: any) => filtering.includes(item.id)));
            else self.banners = cast(list);
        }),
        dismiss() {
            const arrIDs = self.filtered.map((o) => o.id);
            self.root.session.saveDismissedBanners(arrIDs);
        },
    }));
